// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "5fd65798b4638c8169750fc68dc12f0d4bacdaeb/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};